import React from 'react';

import OlLayerBase from 'ol/layer/Base';
import OlLayerVector from 'ol/layer/Vector';

import useMap from '@terrestris/react-geo/dist/Hook/useMap';
import RgLayerTree, {
  LayerTreeProps as RgLayerTreeProps
} from '@terrestris/react-geo/dist/LayerTree/LayerTree';

import LayerTreeNode from '../LayerTreeNode';

export const LayerTree: React.FC<Partial<RgLayerTreeProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const map = useMap();

  if (!map) {
    return <></>;
  }

  const treeNodeTitleRenderer = (layer: OlLayerBase) => {
    return (
      <LayerTreeNode
        layer={layer}
      />
    );
  };

  const filterFunction = (layer: OlLayerBase) => {
    return !(layer instanceof OlLayerVector) && !layer.get('hideInLayerTree');
  };

  return (
    <RgLayerTree
      map={map}
      nodeTitleRenderer={treeNodeTitleRenderer}
      filterFunction={filterFunction}
      {...passThroughProps}
    />
  );
};

export default LayerTree;
